exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (max-width: 768px) {\n.modal-body[data-v-a779f6b8] {\n        max-height: 70vh;\n        overflow-y: auto;\n        padding: 15px;\n}\n}\n", ""]);

// exports
